import { render, staticRenderFns } from "./top-lock.vue?vue&type=template&id=708c54ce&scoped=true"
import script from "./top-lock.vue?vue&type=script&lang=js"
export * from "./top-lock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c54ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('708c54ce')) {
      api.createRecord('708c54ce', component.options)
    } else {
      api.reload('708c54ce', component.options)
    }
    module.hot.accept("./top-lock.vue?vue&type=template&id=708c54ce&scoped=true", function () {
      api.rerender('708c54ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/top/top-lock.vue"
export default component.exports